export const allPlanningApplicationStatuses = ['submitted', 'approved'] as const

export type PlanningApplicationStatus = (typeof allPlanningApplicationStatuses)[number]
